module.exports = __webpack_public_path__ + "d05dd3e99bd2201579efe1c246dc3e.ttf";